import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { GoToAccountSettingsCTA } from "./ctas";

export const WhatIsEoriIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => WHAT_IS_EORI(strictLocalize),
    getDescription: () => [EORI_DEFINITION(strictLocalize)],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return GoToAccountSettingsCTA(strictLocalize);
};

const WHAT_IS_EORI = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "What’s a EORI number?",
    description: {
      text: "Title for the answer of What is EORI number issue",
    },
  });

const EORI_DEFINITION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "The “Economic Operators Registration and Identification” (EORI) number is a unique number used by businesses to identify themselves to customs authorities on customs declarations and other import documentation. Having an EORI number helps prevent potential delays and storage fees if your order is unable to be processed by customs in a timely fashion. We therefore recommend that you obtain an EORI number if you’re importing goods from another country. You can enter your EORI number through the “Import & Tax Info” section on the My Profile tab of your Account Settings page.",
  });
